
import { Image } from "element-ui"
// import inputNumber from "./input-number.vue"
import { set } from "lodash"
import { getUserTrackingInfo } from "@/utils/userId"
import cardInputNumber from "@/components/cms/cardInputNumber.vue"
import { WARE_STATUS } from "@/constants/ware"
import emptyImg from "@/assets/images/empty_img.png"
import { handleAddToCartV2 } from "@/utils/cartResponse"
import {
  showGlobalMessage,
  openNoAddressPop,
  formatWareImgUrl,
  noAddressCheck,
  getDeliveryMethod,
  debounce,
  customSkuKey
} from "@/utils/utils"
import { trackAddToCart, trackSelectItem, handleChangeCartNumber } from "@/utils/track"
import productSku from "@/components/drawer/productSku.vue"
import productCustomSku from "@/components/drawer/productCustomSku.vue"
export default {
  name: "WareViewWare",
  components: {
    [Image.name]: Image,
    cardInputNumber,
    productSku,
    productCustomSku
  },
  inject: {
    getStoreId: {
      default: null
    },
    source: {
      default: null
    },
    hideProTag: {
      default: false
    }
  },
  props: {
    defaultCount: {
      type: [String, Number],
      default: 0
    },
    info: {
      type: Object,
      default: () => ({
        wareImg: "",
        warePrice: "",
        wareName: ""
      })
    },
    defaultMax: {
      type: Number,
      default: 99
    }
  },
  data() {
    return {
      configs: {},
      skuVisible: false,
      customSkuVisible: false,
      config: {},
      max: 99,
      count: 0,
      commonReqParams: {},
      deliveryMethod: "clickCollect",
      debounce: null
    }
  },
  computed: {
    // 是否支持定制
    customContentConfig() {
      return this.config?.preferenceList?.find(item => item.preferenceKey === customSkuKey)
    },
    showSoldTag() {
      return [WARE_STATUS.OUT_OF_STOCK, WARE_STATUS.DISCONTINUED].includes(this.config.wareStatus)
    },
    showProTag() {
      return (
        this.config.promotionWareVO.promotionInfoList &&
        this.config.promotionWareVO.promotionInfoList.length &&
        this.config.promotionWareVO.promotionInfoList[0].displayInfo &&
        this.config.promotionWareVO.promotionInfoList[0].displayInfo.proTag
      )
    },
    hasMutiProTag() {
      return (
        this.config.promotionWareVO.promotionInfoList &&
        this.config.promotionWareVO.promotionInfoList.length &&
        this.config.promotionWareVO.promotionInfoList.length > 1
      )
    },
    proDisplayTag() {
      return (
        this.config.promotionWareVO.promotionInfoList[0].displayInfo &&
        this.config.promotionWareVO.promotionInfoList[0].displayInfo.proTag
      )
    },
    imageUrl() {
      const imgUrl = this.config.wareImg
      if (imgUrl) {
        return formatWareImgUrl(imgUrl)
      }
      return emptyImg
    },
    detailLink() {
      return `${this.MAIN_ORIGIN}${this.MAIN_PATH}/productDetails?skuId=${this.config.sku}&name=${encodeURIComponent(
        this.config.wareName
      )}`
    },
    findSimilarLink() {
      const { sku } = this.config || {}
      return `${this.MAIN_ORIGIN}${this.MAIN_PATH}/similar?skuId=${sku}`
    },
    isComingSoon() {
      return this.config.wareStatus === WARE_STATUS.COMING_SOON
    },
    isShowSimilar() {
      return this.config.wareStatus === WARE_STATUS.OUT_OF_STOCK || this.config.wareStatus === WARE_STATUS.DISCONTINUED
    },
    addCartText() {
      if (this.isComingSoon) {
        return this.$t("common.comingSoon")
      } else if (this.isShowSimilar) {
        return this.$t("common.findSimilar")
      } else {
        return this.$t("common.addToCart")
      }
    }
  },
  watch: {
    defaultCount: {
      handler(newVal) {
        if (newVal !== 0) {
          this.count = newVal
        }
      },
      immediate: true
    },
    defaultMax: {
      handler(newVal) {
        this.max = newVal
      },
      immediate: true
    },
    info: {
      handler(newVal) {
        this.config = newVal
        this.tagHideNo()
      },
      immediate: true
    }
  },
  mounted() {
    this.tagHideNo()
  },
  created() {
    if (!process.client) {
      return
    }
    this.deliveryMethod = getDeliveryMethod()
    const { commonReqParams } = this.$commonParams
    this.storeId = this.getStoreId ? this.getStoreId() : commonReqParams.storeId
  },

  methods: {
    fen2Yuan(num) {
      if (isNaN(num)) return ""
      num = Number(num)
      return (num / 100).toFixed(2)
    },
    getNumber(nums) {
      const num = this.fen2Yuan(nums)
      const str = num.toString()
      const res = str.split(".")
      return res[0]
    },
    getSmallNumber(nums) {
      const num = this.fen2Yuan(nums)
      const str = num.toString()
      const res = str.split(".")
      return res.length === 2 ? res[1] : ""
    },
    handleNumChange(val) {
      handleChangeCartNumber(val, this.count, this.config)
      this.count = val <= 0 ? 0 : val
      this.addcartTrack()
      if (this.count === 0) {
        this.debounce()
        this.debounce = null
      } else {
        this.debounce()
      }
    },
    handleCloseSku() {
      this.skuVisible = false
    },
    handleAdd() {
      this.skuVisible = true
      this.configs = {
        additional: {
          spuId: this.config.spuId,
          sku: this.config.sku,
          count: this.config.count
        },
        skuId: this.config.sku
      }
      trackAddToCart(this.config)
    },
    openCustomSku() {
      this.customSkuVisible = true
      this.configs = {
        additional: {
          sku: this.config.sku,
          stock: this.config.stock
        }
      }
    },
    handleCloseCustomSku(type) {
      this.customSkuVisible = false
      if (type === "save") {
        this.$bus.$emit("add-cart-success", this.source)
        if (this.source === "collect") {
          this.$bus.$emit("reload-collect")
        }
      }
    },
    async handleAddNoSpu() {
      if (this.count > 0) {
        this.debounce = debounce(() => {
          this.debounce = null
        }, 3000)
        this.debounce()
        return
      }
      const loading = this.$loading({
        background: "rgba(0, 0, 0, 0)"
      })
      const [error, data, wareList] = await handleAddToCartV2({
        storeId: this.storeId,
        wares: [{ sku: this.config.sku, beforeCount: 0, count: 1, checked: 1 }],
        sort: 1
      })
      if (data) {
        this.$bus.$emit("add-cart-success", this.source)
        if (this.source === "collect") {
          this.$bus.$emit("reload-collect")
        }
        this.count = this.count + 1
        this.debounce = debounce(() => {
          this.debounce = null
        }, 3000)
        this.debounce()
      }
      if (wareList) {
        const item = wareList.find(v => v.skuId === this.config.sku)
        this.max = item && item.stock ? item.stock : 99
      }
      loading.close()
      trackAddToCart(this.config)
      this.addcartTrack()
    },
    // 添加购物车事件
    addcartTrack() {
      if (this.config?.uclid) {
        const { userId, customLabel1 } = getUserTrackingInfo()
        const value = this.info?.matnr || this.info?.rfId
        const parmas = {
          cliUbid: userId,
          "f.custom_label_1": customLabel1,
          skuId: `SEHK-${value}`,
          productPrices: (this.config?.warePrice / 100).toFixed(2)
        }
        if (this.config?.sellerId) {
          parmas.sellerId = this.config?.sellerId
        } else {
          parmas.sellerId = -1
        }
        this.$onlineSalesSdk.registerAdd2CartEvent(parmas)
      }
    },
    tagHideNo() {
      this.$nextTick(() => {
        const container = this.$refs["span-container"]
        if (!container) return

        const containerWidth = container.offsetWidth
        const children = container.children

        // 重置所有子元素的样式类名
        for (let i = 0; i < children.length; i++) {
          children[i].classList.remove("ellipsis-tag")
          children[i].style.display = ""
        }

        // 计算累积宽度直到超出容器
        let accumulatedWidth = 0
        for (let i = 0; i < children.length; i++) {
          // 获取当前元素的宽度（包括 padding, border, margin）
          const elementWidth = children[i].offsetWidth

          // 获取前一个元素的 margin-right（如果不是第一个元素）
          let marginRight = 0
          if (i > 0) {
            const prevComputedStyle = window.getComputedStyle(children[i - 1])
            marginRight = parseFloat(prevComputedStyle.marginRight)
          }

          // 检查加上当前元素后是否会超出容器
          if (accumulatedWidth + marginRight + elementWidth > containerWidth) {
            // 对当前元素添加省略号样式类名
            children[i].classList.add("ellipsis-tag")

            // 隐藏后续的所有元素
            for (let j = i + 1; j < children.length; j++) {
              children[j].style.display = "none"
            }
            break
          }

          // 更新累积宽度
          accumulatedWidth += elementWidth + marginRight
        }
      })
    },
    trackSelectItem
  }
}
